module.exports = __webpack_public_path__ + "static/Giff-b95d9ebaea136dade2b971a0d3b5277d.jpg";